export default "__VITE_ASSET__DWM50_MY__"